import { Component } from '@angular/core';

@Component({
    selector: 'bb-icon-page-ui',
    templateUrl: './bb-icon-page-ui.component.html',
    standalone: false,
})
export class IconPageComponent {}
